import { withInstall } from '../../../utils/with-install'
import PrismLayer from './PrismLayer.vue'

export const ElAmapLocaPrism = withInstall(PrismLayer)
export default ElAmapLocaPrism
